<template>
  <div class="scroll-container" ref="container">
    <div
        class="scroll-content"
        ref="content"
        @mouseenter="pause"
        @mouseleave="resume"
        @wheel.prevent="handleWheel"
    >
      <div
          v-for="(item, idx) in displayList"
          :key="`${item.id || 'item'}-${idx}`"
          class="scroll-item"
      >
        <div class="nst-in">
          <!-- 排名图标 -->
          <img
              v-if="Number(item.newnum) === 0"
              class="nstim1"
              src="../assets/img/NO1.png"
              @load="onImageLoad"
          />
          <img
              v-else-if="Number(item.newnum) === 1"
              class="nstim1"
              src="../assets/img/NO2.png"
              @load="onImageLoad"
          />
          <img
              v-else-if="Number(item.newnum) === 2"
              class="nstim1"
              src="../assets/img/NO3.png"
              @load="onImageLoad"
          />
          <img
              v-else
              class="nstim1-1"
              :src="require('../assets/num/'+(Number(item.newnum)+1)+'.png')"
              @load="onImageLoad"
              @error="handleRankImageError"
              alt=""
          />

          <div class="flex-hlc" style="width: calc(100% - 75px)">
            <div class="staimg1">
              <img
                  :src="item.img || require('../assets/img/zanwu.png')"
                  @load="onImageLoad"
                  @error="handleContentImageError"
              />
            </div>
            <div style="width: 76%; display: inline-block; float: left;">
              <div class="w100" @click="toarti(item)">
                <el-tooltip
                    class="w100 overflow"
                    effect="dark"
                    :content="item.title || ''"
                    placement="top-start"
                >
                  <el-button class="noborder w100">{{ item.title || '无标题' }}</el-button>
                </el-tooltip>
              </div>
              <div class="wenxiang2 flex-hlc">
                <div>{{ item.gmtCreate || '--' }}</div>
                <div class="wms1">|</div>
                <div class="flex-cc">
                  <img class="wxim1" src="../assets/img/liulan.png" alt="浏览" />
                  <span>{{ item.views || 0 }}</span>
                </div>
              </div>
              <div class="listz3 over3 w100">{{ item.content || '无内容' }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AutoScroll',
  props: {
    datapagelist: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      step: 1,
      speed: 30,
      timer: null,
      isPaused: false,
      currentTop: 0,
      originalHeight: 0, // 单份列表高度
      containerHeight: 0,
      imageLoadCount: 0,
      totalImages: 0
    };
  },
  computed: {
    displayList() {
      if (!Array.isArray(this.datapagelist)) {
        console.warn('[AutoScroll] datapagelist is not an array:', this.datapagelist);
        return [];
      }
      return [...this.datapagelist, ...this.datapagelist];
    }
  },
  watch: {
    datapagelist: {
      handler() {
        this.resetAndInit();
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.init();
    });
  },
  beforeDestroy() {
    this.clearTimer();
  },
  methods: {
    toarti(val) {
      if (!val || !val.id) return;
      this.$router.push({
        path: '/knowledge',
        query: { parentid: val.categoryPid, id: val.categoryId, artiid: val.id }
      });
    },

    // ✅ 安全获取排名图路径（图片在 src/assets/num/）
    getRankImagePath(num) {
      // 根据你实际有的图片调整范围，比如只有 1-6
      if (num >= 1 && num <= 6) {
        try {
          return require(`../assets/num/${num}.png`);
        } catch (e) {
          return require('../assets/img/zanwu.png');
        }
      }
      return require('../assets/img/zanwu.png');
    },

    resetAndInit() {
      this.clearTimer();
      this.currentTop = 0;
      this.$nextTick(() => {
        this.init();
      });
    },

    init() {
      const container = this.$refs.container;
      const content = this.$refs.content;
      if (!container || !content) return;

      this.containerHeight = container.clientHeight;
      // 注意：scrollHeight 是双份高度，所以除以 2 得到单份
      this.originalHeight = content.scrollHeight / 2;

      this.totalImages = this.displayList.length * 2;
      this.imageLoadCount = 0;

      this.startScroll();
    },

    onImageLoad() {
      this.imageLoadCount++;
      if (this.imageLoadCount >= this.totalImages) {
        this.$nextTick(() => {
          const content = this.$refs.content;
          if (!content) return;
          const newOriginalHeight = content.scrollHeight / 2;
          if (newOriginalHeight !== this.originalHeight && this.originalHeight > 0) {
            const ratio = Math.abs(this.currentTop) / this.originalHeight;
            this.originalHeight = newOriginalHeight;
            this.currentTop = -Math.min(ratio * this.originalHeight, this.originalHeight);
            this.applyTransform();
          }
        });
      }
    },

    handleRankImageError(e) {
      e.target.src = require('../assets/img/zanwu.png');
    },

    handleContentImageError(e) {
      e.target.src = require('../assets/img/zanwu.png');
    },

    applyTransform() {
      if (this.$refs.content) {
        this.$refs.content.style.transform = `translateY(${this.currentTop}px)`;
      }
    },

    startScroll() {
      this.clearTimer();
      this.timer = setInterval(() => {
        if (this.isPaused) return;

        this.currentTop -= this.step;
        // ✅ 关键修复：当滚过一整份（originalHeight）时，重置为 0
        // 由于 displayList 是双份，视觉上是连续的
        if (Math.abs(this.currentTop) >= this.originalHeight) {
          this.currentTop = 0;
        }

        this.applyTransform();
      }, this.speed);
    },

    pause() {
      this.isPaused = true;
    },

    resume() {
      this.isPaused = false;
    },

    handleWheel(e) {
      if (!this.isPaused) return;
      const deltaY =  e.deltaY / 3;// 降低滚动速度为原来的 1/3
      let newTop = this.currentTop - deltaY;

      // 手动滚动时，允许在 [0, -originalHeight] 范围内
      if (newTop > 0) newTop = 0;
      if (newTop < -this.originalHeight) newTop = -this.originalHeight;

      this.currentTop = newTop;
      this.applyTransform();
    },

    clearTimer() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.nst-in {
  width: 100%;
  height: 180px;
  margin-bottom: 20px;
}
.wenxiang2 {
  margin-top: 15px;
  margin-bottom: 15px;
}
.staimg1 {
  width: 22%;
  margin-right: 2%;
  max-height: 180px;
  display: inline-block;
  float: left;
  img {
    width: 100%;
    height: auto;
    max-height: 180px;
  }
}
.nstim1,
.nstim1-1 {
  width: 50px;
  height: max-content;
  display: inline-block;
  float: left;
  margin-right: 5px;
}
.scroll-container {
  height: 100%;
  overflow: hidden;
}
.scroll-content {
  transition: transform 0s; /* 禁用过渡，避免手动滚动卡顿 */
  width: 100%;
}
.scroll-item {
  height: 190px;
  box-sizing: border-box;
  padding-bottom: 10px;
}
.listz3 {
  color: white;
}
</style>